enum MyExpApi {
  DASHBOARD_DETAILS = `registrationParticipant/findForDashboard/{id}`,
  PARTICIPANT_DETAILS = `registrationParticipant/findRegistrationParticipantProgramDetails/{id}`,
  PROGRAM_TIMELINE = `participant/getTimeline`,
  RESEND_TICKET = `registrationParticipant/resendConfirmationNumber`,
  BULK_TICKET_DETAIL_FOR_BTA = "bulkTicket/{registrationParticipantId}",
  INITIATE_TICKET_ASSIGNMENT = "participant/registration/initiateByTicketAssignment",
  ASSIGN_TICKET_TO_NON_ATTENDEE = "bulkTicket/assignTicketToNonAttendee",
  REVOKE_BULK_TICKET = "bulkTicket/revokeTicket",
  FETCH_BULK_TICKET_RATE = "bulkTicket/fetchRate",
  INIT_BULK_TICKET_PURCHASE = "bulkTicket/initPurchase",
  GET_PARTICIPANT_LIST_FOR_MANAGEMENT = "registrationParticipant/findParticipantListForManagement",
  FIND_NON_ATTENDEE_REGISTRATION_FORM = "participant/registration/findNonAttendeeRegistrationForm",
  FIND_REGISTRATION_FORM_BY_REG_PARTICIPANT_ID = "registrationParticipant/findRegistrationParticipantProfileForOrganizationAdminNomination",
  NOMINATE_ORG_ADMIN = "registrationParticipant/nonAttendee/nominate",
  REVOKE_ORG_ADMIN = "participant/registration/nonAttendee/removeOrgAdmin",
  INITIATE_NON_ATTENDEE_REGISTRATION = "participant/registration/nonAttendee/initiate",
  FIND_NON_ATTENDEE_UNAPPROVED_APPLICATION_HISTORY = "nonAttendeeApplication/findUnApprovedByApplicantIdAndParticipantSubRole",
  GET_PURCHASE_TICKET_REG_FORM = `participant/registration/findTicketPurchaseForm`,
  GET_PURCHASE_TICKET_REG_FORMS_LIST = "myExperience/registrationForm/findForNonAttendee",
  VALIDATE_COUPON_CODE = `participant/registration/getApplicableDiscount`,
  INITIATE_PURCHASE_TICKET = `participant/registration/purchaseTicket`,
  FIND_PARTICIPANT_PROFILE = "myExperience/registrationParticipant/findProfile",
  UPDATE_PARTICIPANT_PROFILE = "myExperience/registrationParticipant/updateProfile",
  UPLOAD_PROFILE_IMAGE = `registrationParticipant/profilePicture/upload`,
  DELETE_PROFILE_IMAGE = `registrationParticipant/profilePicture/delete`,
  GET_PROGRAM_PARTICIPANTS_FOR_ORG_ADMIN = "programParticipant/findForOrgAdmin",
  MANAGE_BY_ORG_ADMIN = "programParticipant/manageByOrgAdmin",
  PURCHASE_ORDER_LIST = "myExperience/purchaseOrder/list",
  GET_MEETING_PURCHASE_ORDER_LIST = "myExperience/purchaseOrder/meetingPurchaseOrderList",
  SEND_PURCHASE_ORDER_SUMMARY = "myExperience/purchaseOrder/sendPurchaseOrderSummary",
  GET_INVENTORY_TYPE_FORMS = "inventory/{type}/findForm",
  INITIATE_INVENTORY_MEETING_PURCHASE = "inventory/initPurchase/meeting",
  ADD_MEETING_REP_TAG = "programParticipant/meetingRep/add",
  REMOVE_MEETING_REP_TAG = "programParticipant/meetingRep/remove",
  MEETING_REP_ACK_EMAIL_RESEND = "programParticipant/meetingRepAck/sendEmail",
  GET_SELECTION_CONFIGURATION = "selection/findSelectionConfiguration",
  GET_SELECTION_RECIPIENTS_LIST = "selection/findRecipientListBySearchCriteria",
  SELECTION_CREATE_SAVED_FILTERS = "selection/savedSearch/create",
  SELECTION_UPDATED_SAVED_FILTERS = "selection/savedSearch/update",
  SELECTION_DELETE_SAVED_FILTERS = "selection/savedSearch/delete/{id}",
  SHARE_SELECTION_CREATE = "selection/share/create",
  SHARE_SELECTION_DELETE = "selection/share/delete/{id}",
  SHARE_SELECTION_LIST = "selection/findForSelectionShareList",
  GET_SELECTION_LIST = "selection/findSelectionList",
  CREATE_REQUEST_SELECTION = "selection/request/create",
  UPDATE_REQUEST_SELECTION = "selection/request/update",
  CREATE_OPTIN_SELECTION = "selection/optIn/create",
  UPDATE_OPTIN_SELECTION = "selection/optIn/update",
  DELETE_SELECTION = "selection/delete/{id}",
  REMOVE_SELECTION_REQUEST_IN_OPTIN = "selection/request/optOut",
  UPDATE_REQUEST_SELECTION_IN_OPTIN = "selection/request/updateInOptIn",
  SELECTION_ORG_ADMIN_PARTICIPANTS_LIST = "selection/findManagedSenderListForOrgAdmin",
  ADDITIONAL_CHARGE = "myExperience/purchaseOrder/pendingAdditionalChargeList",
  GET_BULK_TICKET_PURCHASE_ORDER_LIST = "myExperience/purchaseOrder/bulkTicketPurchaseOrderList",
  SELECTION_COUNTS = "selection/findForSelectionMultipliersAndCount",
  SELECTION_META_DATA = "selection/findSelectionConfigurationMetadata",
  SELECTION_SHOW_AVAILABILITY_PROMPT_GET = "programParticipant/manageAvailability/showPrompt",
  SELECTION_SHOW_AVAILABILITY_PROMPT_UPDATE = "programParticipant/manageAvailability/updatePrompt",
  //Profile
  GET_TABLETALK_PROFILE = "programParticipant/{id}/profile/tabletalk",
  UPDATE_TABLETALK_PROFILE = "programParticipant/profile/tabletalk/initiateOrUpdate",
  GET_OPTION_FOR_FIELD = "option/findForFieldRenderSubType",
  GET_PROGRAM_PARTICIPANT_TIME_SESSION = "programParticipant/fetchTimeSessions",
  UPDATE_PROGRAM_PARTICIPANT_TIME_SESSION = "programParticipant/update/timeSlot",
  GET_MEETING_PROFILE = "programParticipant/{programParticipantId}/profile/meeting",
  UPDATE_MEETING_PROFILE = "programParticipant/profile/meeting/initiateOrUpdate",
  GET_PROFILE_FOR_DISPLAY = "profile/meeting/getProfileForDisplayByParticipantId",
  GET_ORGANIZATION_PROFILE_FOR_DISPLAY_BY_PARTICIPANT_ID = "myExperience/programOrganization/getProfileForDisplayByParticipantId",
  GET_EVENT_ORGANIZATION_PROFILE_FOR_DISPLAY_BY_PARTICIPANT_ID = "myExperience/eventOrganization/getProfileForDisplay",
  PARTICIPANT_MEETINGS_LIST = "programAgenda/findAll",
  ORGANIZATION_MEETINGS_LIST = "programAgenda/findAllByOrganization",
  PARTICIPANT_MEETING_DETAILS = "programAgenda/findDetail",
  ORGANIZATION_MEETING_DETAILS = "programAgenda/findDetailByProgramOrganization",
  MARK_MEETING_AS_NO_SHOW = "event/participation/markMeetingAsNoShow",
  NOT_ATTENDING_ACTIVITY = "myExperience/activity/cancelParticipationByParticipant",
  REQUEST_FOLLOW_UP = "event/participation/requestFollowup",
  UPDATE_AGENDA_NOTES = "programParticipation/note",
  //Accept Meetings
  GET_ACCEPT_MEETING_LIST = "event/participation/acceptRejectListing/{eventParticipantId}",
  UPDATE_PROGRAM_PARTICIPATION_STATUS = "program/participation/updateStatus",
  ACCEPT_ALL = "event/participation/acceptAll",
  GET_AVAILABLE_ASSOCIATES = "programAgenda/findAvailableAssociates",
  ADD_ASSOCIATE = "programAgenda/addAssociate",
  REMOVE_ASSOCIATE = "programAgenda/removeAssociate",
  GET_PARTICIPATIONS_FOR_ORG_ADMIN_AGENDA_LISTING = "programAgenda/findProgramParticipationsForOrgAdmin",
  GET_REIMBURSEMENT_DETAILS = "participant/reimbursement/findOrCreateByContextEntityIdAndContextEntityType",
  UPDATE_REIMBURSEMENT_FORM_DETAILS = "participant/reimbursementDetail/update",
  UPLOAD_REIMBURSEMENT_RECEIPT = "participant/receipt/upload",
  EDIT_REIMBURSEMENT_RECEIPT = "participant/receipt/edit",
  DELETE_REIMBURSEMENT_RECEIPT = "participant/receipt/delete",
  SUBMIT_REIMBURSEMENT_DETAILS = "participant/reimbursement/submit",
  RE_SEND_INVITE = "programParticipation/sendAssociateReminder",
  GET_PROGRAM_AGENDA_FOR_MEETING_ASSIGNMENT = "programAgenda/findAllForOrgAdminForAssignment",
  GET_MEETING_REP_FOR_ASSIGNMENT = "programAgenda/findMeetingRepForAssignment",
  ASSIGN_MEETING_REP_TO_AGENDA = "programAgenda/assignMeetingRep",
  UNASSIGN_MEETING_REP_TO_AGENDA = "programAgenda/unAssignMeetingRep",
  //Feedback
  GET_FEEDBACK_FORM_BY_EVENT_PARTICIPANT = "programParticipant/feedbackForm/findByEventParticipantId",
  SAVE_FEEDBACK_FORM = "programParticipant/feedback/initiateOrUpdate",
  GET_FEEDBACK_LIST_FOR_ORG_ADMIN = "myExperience/programParticipant/findForOrgAdminFeedbackList",
  DOWNLOAD_REPORT_BY_TYPE = "report/generateByReportType",
  // Reimbursement
  OPT_IN_OUT_REIMBURSEMENT = "programParticipant/update/optOutReimbursement",
  //Org Profile
  ORGANIZATION_PROFILE_GET = "myExperience/programOrganization/{programOrganizationId}/profile/meeting",
  ORGANIZATION_PROFILE_UPDATE = "myExperience/programOrganization/update",
  EVENT_ORGANIZATION_PROFILE_GET = "myExperience/eventOrganization/exhibitor/findById",
  EVENT_ORGANIZATION_PROFILE_UPDATE = "myExperience/eventOrganization/exhibitor/update",
  PRODUCT_LIST_GET = "myExperience/product/findListingAndSchemaByProgramOrganizationId",
  PRODUCT_CREATE = "myExperience/product/create",
  PRODUCT_UPDATE = "myExperience/product/update",
  PRODUCT_DELETE = "product/delete",
  // Associated Program
  ASSOCIATED_PROGRAM_ACTIVITY_UPDATE = "myExperience/associatedProgramActivity/updateByActivityAdmin",
  ASSOCIATED_PROGRAM_ACTIVITY_GET_BY_ID = "myExperience/associatedProgramActivity/{id}",
  ASSOCIATED_PROGRAM_ACTIVITY_LIST_BY_ACTIVITY_ADMIN_ID = "myExperience/associatedProgramActivity/findByActivityAdminId",
  ASSOCIATED_PROGRAM_TIMESLOT_ASSOCIATION_UPDATE = "myExperience/associatedProgramActivity/activityTimeSlot/updateByActivityAdmin",
  ASSOCIATED_PROGRAM_ACTIVITY_LIST_BY_EVENT_PARTICIPANT_AND_PROGRAM_ID = "myExperience/activitySelection/findForParticipant",
  ASSOCIATED_PROGRAM_ACTIVITY_SELECTION_REQUEST_CREATE = "myExperience/activitySelection/request/create",
  ASSOCIATED_PROGRAM_ACTIVITY_SELECTION_REQUEST_UPDATE = "myExperience/activitySelection/request/update",
  ASSOCIATED_PROGRAM_ACTIVITY_SELECTION_REQUEST_DELETE = "myExperience/activitySelection/request/delete/{id}",
  ASSOCIATED_PROGRAM_ACTIVITY_HANDPICK_PARTICIPANT = "myExperience/activitySelection/handpick/create",
  ASSOCIATED_PROGRAM_ACTIVITY_REMOVE_HANDPICKED_PARTICIPANT = "myExperience/activitySelection/handpick/delete/{id}",
  EXHIBITOR_SPONSOR_CONFIGURATION_GET = "eventOrganization/findExhibitorSponsorConfiguration",
  EXHIBITOR_SPONSOR_LIST = "eventOrganization/findExhibitorOrSponsorList",
  GET_BOOKMARKS_LIST = "bookmark/findByRegistrationParticipant",
  BOOKMARK_CREATE = "bookmark/create",
  BOOKMARK_DELETE = "bookmark/delete",
  GET_NOTES_LIST = "note/findByRegistrationParticipant",
  GET_NOTE_DATA = "note/findByRegistrationParticipantForEntity",
  NOTE_CREATE = "note/create",
  NOTE_UPDATE = "note/update",
  NOTE_DELETE = "note/delete",
  ASSOCIATED_PROGRAM_ACTIVITY_FIND_ACTIVITY_FOR_SHORTLIST = "myExperience/activitySelection/findByActivityForActivityAdmin",
  ASSOCIATED_PROGRAM_ACTIVITY_SHORTLIST_PARTICIPANT = "myExperience/activitySelection/shortlistByActivityAdmin",
  ASSOCIATED_PROGRAM_ACTIVITY_LIST_FOR_WORKFLOW = "myExperience/associatedProgramActivity/findForWorkflowByActivityAdminId",
  ASSOCIATED_PROGRAM_GET_ACTIVITY_AGENDAS = "myExperience/activity/findByActivityAdminId",
  ASSOCIATED_PROGRAM_ACTIVITY_AGENDA_STATUS_CHANGE = "myExperience/activity/updateStatus",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_LIST = "myExperience/activity/getParticipation",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_UPDATE = "myExperience/activity/updateParticipation",
  ASSOCIATED_PROGRAM_ACTIVITY_PARTICIPATION_MARK_ATTENDANCE = "myExperience/activity/markAttendance",
  ASSOCIATED_PROGRAM_AGEND_LIST_FOR_MARK_ATTENDANCE = "myExperience/activity/findByActivityAdminIdForReconciliation",
  // Program Header
  SKIPPED_TIMELINE_STAGES_LIST_BY_PROGRAM_ID = "myExperience/program/skipped/timeline",
  ASSOCIATED_PROGRAM_PARTICIPATION_LIST_TO_MARK_ATTENDANCE = "myExperience/activity/getParticipationForReconciliation",
  ADD_TO_SCHEDULE_GET_TIMESLOT_OCCUPANCY_LIST = "addToSchedule/findTimeSlotOccupancyForHeatMap",
  ADD_TO_SCHEDULE_CREATE_AGENDA = "addToSchedule/programAgenda/create",
  ADD_TO_SCHEDULE_UPDATE_AGENDA = "addToSchedule/programAgenda/update",
  ADD_TO_SCHEDULE_DELETE_AGENDA = "addToSchedule/programAgenda/delete/{id}",
  ADD_TO_SCHEDULE_GET_AGENDA_LIST = "addToSchedule/findProgramAgendaList",
  ADD_TO_SCHEDULE_GET_INBOUND_SELECTION_LIST = "selection/findInboundSelectionListForAddToSchedule",

  PARTICIPANTS_LIST_FOR_CALENDAR_INVITE = "myExperience/activityAdmin/findAllApprovedForActivityAdmin",

  SEND_CALENDAR_INVITE_BY_ACTIVITY_ADMIN = "myExperience/activity/sendCalendarInvite",
  ASSOCIATED_PROGRAM_ACTIVITY_ADMIN_INVITE_PARTICIPANT = "myExperience/activity/inviteParticipation",
  ACCEPT_REJECT_ACTIVITY_PARTICIPATION = "myExperience/activity/acceptRejectParticipation",
  GET_SUMMARY_FOR_ACTIVITY = "myExperience/activity/getSummary",
  GET_CONTACT_CONTEXT_BY_EVENT_PARTICIPANT_ID = "contactContext/{contactParticipantId}",
  GET_CONTACT_BY_SEARCH_CRITERIA = "contact/findBySearchCriteria",
  CONTACT_REVOKE = "contact/{contactId}/contactParticipant/{contactParticipantId}/revoke",
  GET_INVENTORY_LIST = "myExperience/inventory/findApplicableInventoryForParticipant",
  GET_INVENTORY_DETAILS = "myExperience/inventory/findById",
  VALIDATE_INVENTORY_COUPON_CODE = `participant/registration/getApplicableDiscountForInventory`,
  INVENTORY_INIT_PURCHASE = `inventory/initPurchase`,
  DOWNLOAD_ALL_CONTACTS = "myExperience/downloadContacts/{contactContextId}",
  GET_CONTACT_CONTEXT_BY_CONTEXT_ID = "contactContext/findById/{contactContextId}",
  UPDATE_CONTACT_CONTEXT = "myExperience/contactContext/updateByContextAdmin",
  GET_PARTICIPANTS_TO_ADD_IN_CONTEXT = "eventParticipant/findAllFromSameEventOrganization",
  GET_CONTACT_CONTEXT_FOR_ADMIN = "myExperience/contactContext/{eventParticipantId}",
  DOWNLOAD_PURCHASE_ORDER = "myExperience/purchaseOrder/downloadPdf",
  TICKET_CHANGE_FORMS_LIST = "protected/registrationFormUpgradeMapping/findByRegistrationParticipantId",
  TICKET_CHANGE_GET_FORM_DETAIL = "participant/registration/findTicketUpgradeForm",
  INITIATE_TICKET_CHANGE = "participant/registration/initiateTicketUpgrade",
  GET_MY_PRIVILEGES_LIST = "myExperience/participant/accessPrivileges/{registrationParticipant}",
  REGISTRATION_GET_ENABLED_FEATURE = "registrationParticipant/getEnabledFeatures",
  BULK_TICKET_ADMIN_LIST = "myExperience/registrationParticipant/getOrganizationBulkTicketAdmins",
  HIDE_PARTICIPANT_FROM_LIST = "myExperience/registrationParticipant/hideFromListing",
  ANALYTICS_EVENT_LOG = "analytics/log",
  UPDATE_OFFLINE_TRANSACTION = "myExperience/transaction/offline/update",
  CANCEL_OFFLINE_TRANSACTION = "myExperience/purchaseOrder/cancelOfflineRequest",
  GET_CONFIGURED_FIELDS_FOR_COLUMN = "myExperience/associatedProgram/prioritizationFields",
  ACTIVITY_PARTICIPANT_PROFILE_VIEW = "myExperience/profile/meeting/getProfileForDisplayByParticipantId",
  AI_TEXT_ENHANCEMENT = "myExperience/aiAssist/textEnhancement",
  VIEW_ALLOCATED_MUTUAL_MATCHES = "emailIntroduction/unscheduledMeetings/findByProgramOrganizationId"
}

export default MyExpApi;
